import { __assign } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common';
import { compKey } from './key';
var layoutClassNames = function (props) {
    var _a, _b, _c;
    return namespacedClassnames(compKey, props.className, (_a = {},
        _a["orientation-".concat(props.orientation)] = props.orientation,
        _a["gap-".concat(props.gap)] = props.gap,
        _a["padding-".concat(props.padding)] = props.padding,
        _a["text-align-".concat(props.textAlign)] = props.textAlign,
        _a), (props.orientation === 'vertical' && (_b = {},
        _b["justify-content-".concat(props.verticalAlignment)] = props.verticalAlignment,
        _b["align-items-".concat(props.horizontalAlignment)] = props.horizontalAlignment,
        _b)), (props.orientation === 'horizontal' && (_c = {},
        _c["justify-content-".concat(props.horizontalAlignment)] = props.horizontalAlignment,
        _c["align-items-".concat(props.verticalAlignment)] = props.verticalAlignment,
        _c)));
};
export var Layout = function (props) {
    return (React.createElement("div", __assign({}, props, { className: layoutClassNames(props) }), props.children));
};
export var Column = function (props) {
    return React.createElement(Layout, __assign({}, props, { orientation: 'vertical' }));
};
export var Row = function (props) {
    return React.createElement(Layout, __assign({}, props, { orientation: 'horizontal' }));
};
//# sourceMappingURL=layout.js.map